export const Lux = () => (
  <svg width="54" height="54" viewBox="0 0 54 54" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <filter
        x="-28.6%"
        y="-28.6%"
        width="157.1%"
        height="157.1%"
        filterUnits="objectBoundingBox"
        id="jse8czrxta"
      >
        <feOffset dy="3" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g transform="translate(8.956 8.95)" filter="url(#jse8czrxta)" fill="#FFF" fillRule="nonzero">
      <path d="M18.508 8.203c-5.606 0-10.181 4.576-10.181 10.182 0 5.606 4.575 10.181 10.181 10.181 5.607 0 10.182-4.534 10.182-10.181 0-5.606-4.534-10.182-10.182-10.182zm0 17.808c-4.204 0-7.626-3.422-7.626-7.626 0-4.205 3.422-7.626 7.626-7.626 4.205 0 7.626 3.421 7.626 7.626 0 4.204-3.421 7.626-7.626 7.626zM17.189 0h2.679v5.029h-2.679zM6.418 4.346l3.555 3.557-1.895 1.894L4.523 6.24zM0 16.901h5.029v2.679H0zM6.221 32.245 4.326 30.35l3.556-3.556 1.895 1.894zM16.901 31.741h2.679v5.029h-2.679zM30.35 32.443l-3.556-3.557 1.895-1.894 3.555 3.556zM31.741 17.189h5.029v2.679h-5.029zM30.528 4.522l1.895 1.895-3.556 3.556-1.895-1.894z" />
    </g>
  </svg>
);
